import { render, staticRenderFns } from "./MediaBody.vue?vue&type=template&id=1887c942&scoped=true&"
import script from "./MediaBody.vue?vue&type=script&lang=js&"
export * from "./MediaBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887c942",
  null
  
)

export default component.exports